import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import AddOrEditLeadDeo from "../../components/datagrid/deo/AddOrEditLeadDeo";
import { Box, Button, Paper, Stack } from "@mui/material";
import { deoLeadTableHeader } from "../../components/datagrid/deo/deoLeadTableHeader";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import { useSelector } from "react-redux";
import useResponsive from "../../Hooks/useResponsive";
import { useDispatch } from "react-redux";
import { getActiveCoursesForDeo, getClass, getLeadsForDeo, getSyllabus } from "../../redux/features/deoSlice";
import dayjs from "dayjs";
import FromAndToDatePicker from "../../components/mui/FromAndToDatePicker";
import ActionDetails from "../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../components/mui/GlobalAnchor/GlobalAnchorList";
import { use } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import DeoLeadsBulkUpload from "./DeoLeadsBulkUpload";

const DeoLeadsView = () => {
  const navigate = useNavigate("");
  const mdDown = useResponsive("down", "md");
  const [fromDate, setFromDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [direction, setDirection] = useState("row");
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { resData, loading } = useSelector((store) => store.deo);
  const { data, meta } = resData;
  const dispatchParams = {
    paginationData,
    fromDate,
    toDate,
  };

  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getLeadsForDeo(dispatchParams));
    }
  }, [gridSize, pageNum, search]);
  useEffect(() => {
    dispatch(getActiveCoursesForDeo());
    dispatch(getSyllabus());
    dispatch(getClass());

  }, []);

  return (
    <GlobalWrapper
      title="Deo Leads"
      actions={
        <Stack gap={1}>
          <AddOrEditLeadDeo dispatchParams={dispatchParams} />
          <DeoLeadsBulkUpload dispatchParams={dispatchParams} />
        </Stack>
      }
    >
      <Box sx={{ display: "flex", flexDirection: direction }}>
        <Box sx={{ flex:0.5 }}>
        <FromAndToDatePicker
          fullWidth={true}
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </Box>
        
        </Box>
      <Box mt={2}>
        <Paper elevation={3}>
          <GlobalDatagrid
            tableHead={deoLeadTableHeader}
            rows={data || []}
            meta={meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            actionComponent={
              <>
                <ActionDetails val={rowData?.lead_name} />
                <GlobalAnchorList 
                  label="Update"
                  component={<AddOrEditLeadDeo  dispatchParams={dispatchParams} row={rowData} />}
                />
                   <GlobalAnchorList
                  component={
                    <Box>
                      <Button
                        sx={{
                          p: "7px",
                          px: "10px",
                          background:
                     "linear-gradient(135deg, #2f72b3, #1e65ab6e)",
                          color: "#fff",
                          "&:hover": {
                            background:
                            "linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))",
                          },
                        }}
                        onClick={() =>
                          navigate(`/assessment-tool/student-registration`)
                        }
                        variant="outlined"
                      >
                        <Icon
                          icon="mingcute:user-search-fill"
                          width="20"
                          height="20"
                        />
                        Go To Take Assessment
                      </Button>
                    </Box>
                  }
                />
              </>
            }
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default DeoLeadsView;
